export const SET_PLACEMENT_MODE = 'SET_PLACEMENT_MODE';

export const setPlacementMode = (mode) => ({
  type: SET_PLACEMENT_MODE,
  payload: {
    mode,
  },
});
